import styled from '@emotion/styled';

export const Wrapper = styled.div`
  width: 100%;
`;

export const Top = styled.div`
  display: flex;
  width: 100%;
`;

export const Right = styled.div`
  width: 100%;
  margin: 0 16px;
`;

export const Content = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 80px;
`;

export const StateWrapper = styled.div`
  position: absolute;
  left: 50%;
  top: 300px;
  transform: translate(-50%, -50%);
`;

export const Tabs = styled.div`
  margin-top: 16px;
  display: flex;
  background: #a7a7a7;
  border-radius: 40px;
  height: 56px;
  width: 360px;
`;

export const Tab = styled.div<{
  active?: boolean;
}>`
  width: 160px;
  font-size: 18px;
  font-weight: 600;
  color: ${(props) => (props.active ? '#000' : '#fff')};
  background-color: ${(props) => (props.active ? '#fff' : '')};
  padding: 8px 16px;
  margin: 8px;
  border-radius: 40px;
  text-align: center;
  transition: all 0.1s ease-in;
  line-height: 1.2;
`;
